import { Input } from "@/components/forms";
import { Button, Card, FixedFooter, Text } from "@/components/ui";
import { AddressSchemaType } from "@/types/forms";
import { FieldErrors, UseFormRegister } from "react-hook-form";

/**
 * Last step after the pin is confirmed. Street, number and district stay as typed. Only complement and reference edit.
 */
export function AddressFinishStep({
  fields,
  register,
  errors,
  loading,
  onSave,
  onEditAddress,
}: {
  fields: AddressSchemaType;
  register: UseFormRegister<AddressSchemaType>;
  errors: FieldErrors<AddressSchemaType>;
  loading: boolean;
  onSave: () => void;
  onEditAddress: () => void;
}) {
  return (
    <>
      <form
        id="addressFinishForm"
        className="flex flex-col gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          onSave();
        }}
      >
        <Card>
          <Text size="sm" weight="semibold" tone="default">
            {[fields.street, fields.number].filter(Boolean).join(", ")}
          </Text>
          <Text size="sm" tone="muted">
            {[fields.district, fields.city, fields.state, fields.postalCode].filter(Boolean).join(" · ")}
          </Text>
          <Text size="xs" tone="subtle" className="mt-2">
            Rua, número e bairro ficam como você preencheu. O pin só marca o ponto no mapa.
          </Text>
          <Button
            type="button"
            variant="outline"
            tone="neutral"
            size="sm"
            className="mt-3"
            disabled={loading}
            onClick={onEditAddress}
          >
            Editar endereço
          </Button>
        </Card>

        <Card className="flex flex-col gap-6">
          <Input
            name="complement"
            label="Complemento"
            error={!!errors.complement}
            registerAction={register}
            placeholder="Apto, bloco, casa…"
            disabled={loading}
            required={false}
          />
          <Input
            name="reference"
            label="Referência"
            error={!!errors.reference}
            registerAction={register}
            placeholder="Ponto de referência"
            disabled={loading}
            required={false}
          />
        </Card>
      </form>

      <FixedFooter>
        <Button type="submit" form="addressFinishForm" size="lg" fullWidth disabled={loading}>
          Salvar endereço
        </Button>
      </FixedFooter>
    </>
  );
}
